import React, { useState } from 'react';
import { StyleSheet, View, FlatList, TouchableOpacity, TouchableWithoutFeedback, Keyboard, Pressable } from 'react-native';
import { Text, Button } from 'react-native-paper';
import CustomModal from './CustomModal';
import theme from './../../lib/theme.js';

const CustomAlert = (props) => {
  const { alertVisible, setAlertVisible, title = "Atención", text = "default", onAccept = null, onCancel = null } = props;

  const ModalContent = (props) => {
    const styles = StyleSheet.create({
      textStyle: {
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
      },
      modalText: {
        marginTop: 10,
      },
      container: {
        width: "100%"
      }
    });

    return (
      <View style={styles.container}>
        <Text variant='titleLarge'>{title}</Text>
        <Text variant="bodyLarge" style={styles.modalText}>{text}</Text>
        {onAccept !== null &&(
          <>
            <Button onPress={() => onAccept()} mode="contained" style={{ marginTop: 10, marginBottom: 10 }}>
              Aceptar
            </Button>
          </>)}
        {onCancel !== null && (
          <>
            <Button onPress={() => onCancel()} mode="contained" style={theme.buttons.error}>
              Cancelar
            </Button>
          </>
        )}
      </View>
    );

  }
  return (
    <CustomModal modalVisible={alertVisible} setModalVisible={setAlertVisible} Content={ModalContent}/>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 22,
  },
  modalView: {
    margin: 10,
    backgroundColor: 'white',
    borderRadius: 20,
    padding: 20,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  textStyle: {
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  modalText: {
    marginBottom: 15,
    textAlign: 'left',
  },
  modalText: {
    marginBottom: 15,
    textAlign: 'left',

  },
  background: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    height: "100%",
    opacity: 0.25,
    zIndex: -1,
  },
});

export default CustomAlert;